import React from "react";
import { CheckBoxItemContainer, Checkbox, CheckboxLabel } from "../styled";

const CheckboxItem = ({ layer, checked, onClick }) => {
  return (
    <CheckBoxItemContainer>
      <Checkbox checked={checked} onClick={() => onClick(!checked, layer)} />
      <CheckboxLabel>{layer?.name}</CheckboxLabel>
    </CheckBoxItemContainer>
  );
};

export default CheckboxItem;
